module.exports = __webpack_public_path__ + "img/mk.30f485bc.svg";